/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type billing_GenerateInvoicesRequest = {
    /**
     * BatchSize - optional number of contracts to process per batch
     */
    batch_size?: number;
    /**
     * ChildIDs - optional list of child IDs to filter by
     */
    child_ids?: Array<string>;
    /**
     * ChildcareIDs - optional list of childcare IDs to filter by
     */
    childcare_ids?: Array<string>;
    /**
     * ContractType - optional contract type filter ("regular", "subsidised", "all")
     */
    contract_type?: billing_GenerateInvoicesRequest.contract_type;
    /**
     * DryRun mode - if true, calculates but doesn't save invoices
     */
    dry_run?: boolean;
    /**
     * ExcludeContractIDs - optional list of contract IDs to exclude from generation
     */
    exclude_contract_ids?: Array<string>;
    /**
     * GroupIDs - optional list of group IDs to filter by
     */
    group_ids?: Array<string>;
    /**
     * Month for invoice generation (1-12) (required)
     */
    month: number;
    /**
     * RetryContractIDs - optional list of contract IDs to retry (for retry-failed-only functionality)
     */
    retry_contract_ids?: Array<string>;
    /**
     * Year for invoice generation (required). Accepted range is 2017-2100.
     */
    year: number;
};
export namespace billing_GenerateInvoicesRequest {
    /**
     * ContractType - optional contract type filter ("regular", "subsidised", "all")
     */
    export enum contract_type {
        REGULAR = 'regular',
        SUBSIDISED = 'subsidised',
        ALL = 'all',
    }
}

